﻿$.fn.dxCtrlBuilderEmail = function custom_dxCtrlBuilderEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemail dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmail(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "grid_builder"
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
    if (typeof option.isFormulaire == 'undefined') option.isFormulaire = false

    this.isDirty = function (value) {
        if (typeof value != 'undefined') dxBuilderEmailPage.isDirty = value
        return dxBuilderEmailPage.isDirty
    }

    var jauge = null
    var ctrlResize = null;
    var dxBuilderEmailPage = null
    function mConstruit() {
        container.empty()
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right = true
        ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlSplitterResize2({
            bddCtrl: option.bddCtrl,
            context_grid: option.context_grid,
            //collapsibleLeft: true,
            //collapsibleRight: true,
            withMarge: false,
            widthLeftInitial: container.innerWidth() / 2
        }).dxCtrlSplitterResize2("instance")
        ctrlResize.mConstruitLeft(function (contentElement) {
            contentElement.empty()
            dxBuilderEmailPage = $("<div style='border:" + theme.border + ";'/>").appendTo(contentElement).dxCtrlBuilderEmailPage({
                bddCtrl: option.bddCtrl,
                html: option.html,
                dxBtUndo: option.dxBtUndo,
                dxBtRedo: option.dxBtRedo,
                jauge:jauge,
                lstfileheberge: option.lstfileheberge,
                onDemandeIdComEmailEnvoi: option.onDemandeIdComEmailEnvoi,
                onDeclencheSaveAuto: option.onDeclencheSaveAuto,
                onDemandeTag: option.onDemandeTag,
                isFormulaire: option.isFormulaire,
                onValueChangedDevexpress: option.onValueChangedDevexpress,
                onDemandeVisuHideTestAcid: function () { mShowHideTestAcid() }
            }).dxCtrlBuilderEmailPage("instance")
            if (typeof option.onContentReady != 'undefined') option.onContentReady(Me)
        })
        ctrlResize.mHideRight()
        window.setTimeout(function () {
            ctrlResize.mHideRight()
        }, 100)
    }

    this.mTitre = function (value) {
        return dxBuilderEmailPage.mTitre(value)
    }
    this.mNom = function (value) {
        return dxBuilderEmailPage.mNom(value)
    }

    this.mGetHtml = function () { return dxBuilderEmailPage.mGetHtml() }

    this.getCurrentEditorHtml = function () {
        return dxBuilderEmailPage.getCurrentEditorHtml()
    }

    var dxTestAcid = null
    function mShowHideTestAcid() {
        if (typeof option.idTestAcid == 'undefined') option.idTestAcid = ""
        if (typeof option.dateTestAcid == 'undefined') option.dateTestAcid = ""
        if (typeof option.dateDocument == 'undefined') option.dateDocument = ""
        if (dxTestAcid != null) {
            ctrlResize.mHideRight()
            ctrlResize.mConstruitRight(function (contentElement) { contentElement.empty() })
            dxTestAcid.element().remove()
            dxTestAcid = null
        }
        else {
            ctrlResize.mShowRight()
            ctrlResize.mConstruitRight(function (contentElement) {
                dxTestAcid = $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlEmailPrevisualisationAcid({
                    bddCtrl: option.bddCtrl,
                    onDemandeUrl: option.onDemandeUrl, //function (func) { func("") }
                    onDemandeHtml: function () { return dxBuilderEmailPage.mGetHtml() },
                    idTestAcid: option.idTestAcid,
                    dateTestAcid: option.dateTestAcid,
                    dateDocument: option.dateDocument,
                    onNewTest: function (idTest) {
                        isDirtyTest = true
                        option.idTestAcid = idTest
                        if (idTest.length > 0) { option.dateTestAcid = new Date() }
                        else { option.dateTestAcid = "" }
                        option.onNewTest(idTest)
                    },
                    objet: "",
                    onClose: function () { }
                }).dxCtrlEmailPrevisualisationAcid("instance")
            })
        }
    }

    this.element = function () { return container }

    mConstruit();
}